<app-selection-list-modal
  [id]="id"
  [title]="title"
  [searchPlaceholder]="searchPlaceholder"
  [fetchConfig]="fetchConfig"
  [sections]="{
    columns,
    contentHeader: sections.contentHeader,
    disclaimer: sections.disclaimer,
    footer: sections.footer
  }"
  [filters]="filters"
  [emptyMessage]="emptyMessage"
  (cancel)="onCancel()"
>
  <ng-template #actionsHeader></ng-template>
  <ng-template #actionsCell let-item>
    <app-pencil-button
      class="select-button"
      theme="secondary-outline"
      [attr.data-name]="id + '-select-item'"
      (clickEvent)="onClick(item)"
    >
      {{ selectButtonText || ('Select' | translate) }}
    </app-pencil-button>
  </ng-template>
</app-selection-list-modal>
